export default __webpack_public_path__ + "static/media/illustration-mian-m@3x.a2ccd26d.webp";